import React from 'react';
import './styles.scss';
import { LogicOp } from 'Core-utils/types/rules.types';

interface LogicBadgeProps {
    logic: LogicOp;
    interactive?: boolean;
    onClick?: () => void;
}

const LogicBadge = ({ logic, interactive = false, onClick }: LogicBadgeProps) => (
    <span
        className={`rb-logic-badge rb-logic-badge--${logic}${interactive ? ' rb-logic-badge--interactive' : ''}`}
        onClick={interactive ? onClick : undefined}
        title={interactive ? `Click to toggle ${logic === 'and' ? 'OR' : 'AND'}` : undefined}
    >
        {logic.toUpperCase()}
    </span>
);

export default LogicBadge;
